import { ChunkDetail, DbChunkDetail } from './chunk-detail';

export interface DbGridAnswer {
  text: string;
  doc_uid: string;
  chunk_hash: string;
  chunk_details: { [key: string]: DbChunkDetail };
  previous_chunk_detail?: DbChunkDetail;
  following_chunk_detail?: DbChunkDetail;
}

export interface TextItem {
  text?: string;
  ref?: string;
  index?: number;
}

export class GridAnswer {
  questionId: number;
  text: string;
  chunkDetails: { [key: string]: ChunkDetail };
  textWithRefs: TextItem[] = [];

  constructor(question_id: number, dbGridAnswer: DbGridAnswer) {
    this.questionId = question_id;
    this.text = dbGridAnswer.text;
    this.chunkDetails = dbGridAnswer?.chunk_details
      ? Object.keys(dbGridAnswer?.chunk_details).reduce(
          (acc, key) => ({ ...acc, [key]: new ChunkDetail(dbGridAnswer?.chunk_details[key]) }),
          {}
        )
      : {};
  }
}
